module.exports = __webpack_public_path__ + "assets/img/app-3.c597b117.png";